import Vue from 'vue';
import Router from 'vue-router';

import ShowList from './views/ShowList.vue';
import Show from './views/Show.vue';
import Package from './views/Package.vue';
import Basket from './views/Basket.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Profile from './views/Profile.vue';
Vue.use(Router);

const router = new Router({
  base: process.env.VUE_APP_PATH,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: ShowList
    },
    {
      path: '/whatson',
      name: 'show-list',
      component: ShowList
    },
    {
      path: '/whatson/:showId',
      name: 'show',
      component: Show,
      props: true
    },
    {
      path: '/package/:packageId',
      name: 'package',
      component: Package,
      props: true
    },
    {
      path: '/whatson/:showId/:performanceId',
      name: 'performance',
      component: Show,
      props: true
    },
    {
      path: '/whatson/:showId/:performanceId?/:productId',
      name: 'product',
      component: Show,
      props: true
    },
    {
      path: '/basket',
      name: 'basket',
      component: Basket
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: { requiresAuth: true }
    },
    { path: '*', component: ShowList }
  ]
});

router.beforeEach((to, from, next) => {
  var session = JSON.parse(localStorage.getItem('session'));
  const loggedIn = !!(session != null ? session.user : false);

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login');
  }
  next();
});

export default router;
